"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRelayStore;

var _relayRuntime = require("relay-runtime");

function createRelayStore(records, options) {
  var source = records == null ? new _relayRuntime.RecordSource() : new _relayRuntime.RecordSource(records);
  return new _relayRuntime.Store(source, options);
}